import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import {Helmet} from "react-helmet";
import Header from '../common/ToolsHeader';
import Settings from './settings';
import React from 'react';
import Tabs from './tabs';
import MobileCover from '../common/MobileCover';
import Authentication from '../common/Authentication';
import { useUserId, userSubscribed } from '../utils/authentication';
import LoginRegisterContainer from '../common/LoginRegisterContainer';
import { useSelector } from 'react-redux';
import { IRootState } from '../../store/reducer';
import Subscribe from '../common/Subscribe';

const useStyles = makeStyles((theme: Theme) =>createStyles({
    root: {
      minHeight: "100vh",
      backgroundColor: "#000A16",
      color: theme.palette.common.white,
      fontFamily: "Roboto",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    contentWrapper: {
      flexGrow: 1,
    },
  })
);

const queryClient = new QueryClient();


const PostContestSim = () => {
  const classes = useStyles();
  const { authenticated, selectedSite, selectedSport } = useSelector((state: IRootState) => state.common);
  const isUserSubscribed = userSubscribed(authenticated, selectedSite, selectedSport);
  const userId = useUserId();
  
  return (
    <QueryClientProvider client={queryClient}>
      <Authentication app='CONTESTSIM'>
      <Helmet>
        <title>Pre-Contest Simulator</title>
        <meta name='description' content='Stokastic Pre-Contest Simulator' />
      </Helmet>
      <MobileCover>
        <Grid className={classes.root}>
          <Grid item xs={12}><Header /></Grid>
          {
            userId ? (
              <Grid
                container
                item
                xs={12}
                direction="column"
                className={classes.contentWrapper}
              >
                <Grid item xs={12}>
                  <Settings />
                </Grid>
                {
                  (isUserSubscribed) ? (
                    <Grid container item xs={12} style={{ flexGrow: 1, padding: 0 }}>
                      <Tabs />
                    </Grid>
                  ) : <Subscribe toolName='Pre-Contest Simulator' />
                }
              </Grid>
            ) : <LoginRegisterContainer toolName='Pre-Contest Simulator' />
          }
        </Grid>
      </MobileCover>
      </Authentication>
    </QueryClientProvider>

  )
}

export default PostContestSim;